import { FilterableList } from "../filterable-list";
import { Helpers } from "../helpers/helpers";
import { FilterParameter } from "../models/types"
import {ResourceList, ResourceViewModel} from "./resource-list";

export class ArticleList extends FilterableList<ResourceViewModel>
{
	filterWrapper: HTMLElement;
	public constructor() {
		super(".article-section .card-list");
	}

	createResult(dataItem: ResourceViewModel): void {
		let template = ResourceList.createResourceCard(dataItem);
		this.resultsWrapper.append(template);
	}

	clearResults(): void {
		if (this.resultsWrapper) {
			this.resultsWrapper.innerHTML = "";
		}
	}

	onQueryChange(selectedFilters: FilterParameter[]): void {
		if (selectedFilters.length > 0) {
			document.querySelector('.section-expandable.expanded')?.classList.remove('expanded');
		}
		this.search("/resources/articles/search", selectedFilters, false);
	}

	toggleLoader(isLoading: boolean): void {
		var loader = document.querySelector('.article-section .loader');

		if (isLoading) {
			loader.classList.remove('d-none');


		} else {
			loader.classList.add('d-none');
			this.resultsWrapper.classList.remove('d-none');
			this.paginationContainer.classList.remove('d-none');
		}
	}



}
